import React, { memo, useCallback } from 'react';
import useCard from 'context/CardContext';
import buttonStyles from 'assets/css/Button.module.css';
import AceAnswersEventPartials from 'Components/Card/Partials/Partials.AceAnswersEvent';
import EventPartials from 'Components/Card/Partials/Partials.Event';
import { fetchHelper } from '@ace/react-utilities';
import { useMutation } from 'react-query';
import * as Sentry from "@sentry/react";

export default function AceAnswersAvailableEvent(props) {
    //render
    return (
        <AceAnswersEventPartials.EventDisplay {...props} >
            <AceAnswersAvailableEventRegisterBtn {...props} />
        </AceAnswersEventPartials.EventDisplay>
    )
}

const UpgradeRequiredBtn = memo(() => (<span className={`${buttonStyles.stroke} ${buttonStyles.strokeDisabled} disabled-link-event`}>Upgrade Required</span>));
const RegisteredBtn = memo(() => (<span className="registered-event">Registered</span>));
const RegisteringBtn = memo(() => (<span className="loading-register-event">Registering...</span>));

function AceAnswersAvailableEventRegisterBtn(props) {
    //local var(s)
    const { event, eligible } = props;

    //context(s)
    const { refreshCard } = useCard();

    const { 
        mutate: registerForEvent,
        reset: registerReset,
        isSuccess: isRegistered,
        isLoading: isRegistering
      }  = useMutation(callbackUrl => fetchHelper(callbackUrl, { method: 'POST' }), {
        onSuccess: () => {
            setTimeout(() => { 
                refreshCard();
                registerReset();
            }, 5000);
        },
        onError: (error) => {
            Sentry.captureException(error);
        }
    });

    //event(s)
    const handleRegisterClick = useCallback(() => {
        registerForEvent(event.CanonicalUrl);
    }, [event.CanonicalUrl, registerForEvent]);

    const RegisterBtn = () => {
        return (
            <button className={`${buttonStyles.stroke} ${buttonStyles.micro} eligible-event`} onClick={() => handleRegisterClick()}>
                Register
                <EventPartials.WrappedIconAngleRight />
            </button>
        );
    }

    //render
    if (!eligible) {
        return <UpgradeRequiredBtn />;
    } else if (isRegistered) {
        return <RegisteredBtn />;
    } else if (isRegistering) {
        return <RegisteringBtn />;
    } else {
        return <RegisterBtn />;
    }
}
